import { freightBookingIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const fulfillFulfillmentGroupWithFreightBooking = {
  name: "fulfillFulfillmentGroupWithFreightBooking" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    freightBookingId: freightBookingIdFormat.schema,
  }),
  output: z.object({}),
};
